import React from 'react';
import classNames from 'classnames/bind';
import { Trans } from 'react-i18next';

import PaidText from './PaidText';
import styles from './PaidPeriod.scss';


type Props = {
  isPaid: boolean,
  isFree: boolean,
  paymentTo: string,
  footnotes: Object,
};

const cx = classNames.bind(styles);

const PaidPeriod = ({ isPaid, isFree, paymentTo, footnotes }: Props) => (
  <div className={cx({ info: true, danger: !isPaid })}>
    {isPaid
      ? (paymentTo && <span>
        <PaidText paymentTo={paymentTo} isFree={isFree} />
        {footnotes
          && footnotes.monthDailyPause
          && <sup className={styles.fn}>{footnotes.monthDailyPause.index}</sup>}
      </span>)
      : <span><Trans i18nKey="subs:insufficient_funds">Недостаточно средств</Trans></span>}
  </div>
);

export default PaidPeriod;
